<template>
  <!-- 新增角色 -->
  <div class="addArticle">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="rigth" label-width="100px"
        :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="选择分类" prop="sortId">
            <el-cascader style="width: 500px" v-model="addForm.sortId" :options="sortList" :props="sortProps"></el-cascader>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="addForm.title" clearable style="width:200px"
              placeholder="文章标题"></el-input>
          </el-form-item>
          <el-form-item label="文章作者" prop="author">
            <el-input v-model="addForm.author" clearable style="width:200px"
              placeholder="文章作者"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="单位名称" prop="unitName">
            <el-input v-model="addForm.unitName" clearable style="width:200px"
              placeholder="单位名称"></el-input>
          </el-form-item>
          <el-form-item label="标签" prop="tags">
            <el-input v-model="addForm.tags" clearable style="width:200px"
              placeholder="标签"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="摘要" prop="remark">
            <el-input v-model="addForm.remark" clearable style="width:200px"
              placeholder="摘要"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
            <el-input-number v-model="addForm.sort" :min="1"
              style="width:200px;text-align:left;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="封面图片" prop="imgUrl">
            <upload @fileChange="uploadImg" accept="image/jpg,image/jpeg,image/png" :multiple="true"></upload>
            <img-view style="margin-left: 20px" :imgList="[{url: coverImg, id: 0}]"></img-view>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="文章内容" prop="content">
            <tinymce :value="addForm.content" @input="change" :isEditorLoad="isEditorLoad"></tinymce>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="margin-top:20px">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js"
import Tinymce from "@/components/Tinymce";

export default {
  name: 'addArticle',
  components: {
    Tinymce
  },
  data() {
    return {
      /**新增表单 */
      addForm: {
        id: 0, // 文章ID
        sortId: '', // 分类ID
        status: 2, // 状态
        author: '', // 作者
        unitName: '', // 单位名称
        tags: '', // 标签
        title: '', // 标题
        remark: '', // 摘要
        imgUrl: '', // 图片地址
        content: '', // 文章内容
        sort: 1, // 排序
      },
      /**新增表单规则 */
      addFormRule:{
        sortId: [ mustFill ], // 分类ID
        title: [ mustFill ], // 标题
        sort: [ mustFill ], // 排序
      },
      /**功能列表 */
      sortList: [], // 文章分类
      sortProps: { value: 'id', label: 'title', children: 'childs', checkStrictly: true, emitPath: false },
      coverImg: '', // 封面图片演示
      isEditorLoad: false, // 编辑器是否加载完成
    }
  },
  mounted(){
    //接收role传递参数
    let row = JSON.parse(decodeURIComponent(this.$route.query.row))
    if (row) {
      this.addForm.id = row.id
      this.getData()
    }
    this.getSort() // 获取文章分类
  },
  methods:{
    // 获取文章详情
    getData(){
      let data = {
        msgId: this.addForm.id
      }
      this.$request({
        url: 'Article/ArticleMessageDetail',
        method: "post",
        data: data
      }).then(res => {
        if (res.success) {
          let item = res.model
          this.addForm.title = item.Title
          this.addForm.sortId = item.CategoryId
          this.addForm.author = item.Author
          this.addForm.unitName = item.Organization
          this.addForm.tags = item.Tags
          this.addForm.remark = item.ZhaiYao
          this.addForm.sort = item.SortId
          this.addForm.imgUrl = item.ImgUrl
          this.coverImg = this.$setImgUrl(item.ImgUrl)
          this.addForm.content = decodeURIComponent(atob(item.Content || ''))
          this.isEditorLoad = true
          this.addForm.status = item.Status
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /** 获取文章分类 */
    getSort(){
      let data = {
        navType: 'HomePage',
        status: 2,
      };
      this.$request({
        url: 'Navigation/GetNavigationAll',
        method: "post",
        data: data
      }).then((res) => {
        this.sortList = []
        if (res.success) {
          this.changeArr(res.list || [])
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /**递归调用函数 */
    changeArr(list) {
      let obj = {}
      obj[0] = []
      for(let i = 0; i < list.length; i++) {
        let item = list[i]
        let itemData = this.setTabelItem(item)
        if(item.rank == 1){
          obj[0].push(itemData)
        }else{
          if(!obj[item.parent_id]){
            obj[item.parent_id] = []
          }
          obj[item.parent_id].push(itemData)
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        for(let j = 0; j < (obj[obj[0][i].id] || []).length; j++){
          obj[obj[0][i].id][j].childs = obj[obj[obj[0][i].id][j].id]
        }
        obj[0][i].childs = obj[obj[0][i].id]
      }
      this.sortList = obj[0]
    },
    // 设置分类数据格式
    setTabelItem(item){
      return {
        id: item.Id,
        title: item.title,
        rank: item.rank + '',
        sort: item.sort_id,
        status: item.status,
        channelId: item.channel_id,
        parentId: item.parent_id + '',
        name: item.name,
        icon: item.icon_url,
        navType: item.nav_type,
      }
    },

    uploadImg(file){
      if (file.length) {
        const formData = new FormData()
        formData.append("file", file[0])
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        }).then((res) => {
          if(res.flag == 0){
            this.addForm.imgUrl = res.message
            this.coverImg = this.$setImgUrl(res.message)
          }else{
            this.$message.error(res.message);
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    
    /**富文本编辑内容改变回调 */
    change(val) {
      this.addForm.content = val
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    /**提交表单 */
    submitForm(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let data = {
            entId: window.localStorage.getItem('entId'),
            MsgId: this.addForm.id,
            CategoryId: this.addForm.sortId,
            Status: this.addForm.status,
            Author: this.addForm.author,
            Organization: this.addForm.unitName,
            Tags: this.addForm.tags,
            Title: this.addForm.title,
            ZhaiYao: this.addForm.remark,
            LinkUrl: '',
            ImgUrl: this.addForm.imgUrl,
            Content: btoa(encodeURIComponent(this.addForm.content)),
            SortId: this.addForm.sort,
            Click: '',
            Collect: '',
          }
          this.$request({
            url: "Article/EditorArticles",
            method: "post",
            data: data,
          }).then((res) => {
            if(res.success) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.goBack()
            } else {
              //失败提示
              this.$message({
                message: res.message,
                type: 'error'
              })
            }
          }).catch((err) => {
            window.console.log(err);
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.addArticle{
  width: 100%;
  height: 100%;
}
</style>
